var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTraverseByRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 12.3334H5.6665V17.3334H0.666504V12.3334Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 6.50002H5.6665V11.5H0.666504V6.50002Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49984 12.3334H11.4998V17.3334H6.49984V12.3334Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49984 6.50002H11.4998V11.5H6.49984V6.50002Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 12.3334H17.3332V17.3334H12.3332V12.3334Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 6.50002H17.3332V11.5H12.3332V6.50002Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3332 5.66669V0.666687L17.3332 3.16669L12.3332 5.66669Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 2.33335H12.3332V4.00002H0.666504V2.33335Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraverseByRow);
export default __webpack_public_path__ + "static/media/TraverseByRow.db0ad7f920e92d892e38d5bb39e405e9.svg";
export { ForwardRef as ReactComponent };